import type { OperationContext } from 'urql';
import { useCallback } from 'react';

import { getResultOrError } from '../utils/errors';
import { useCreatePaymentAccountVerificationTokenMutation } from './internalApi';

export const usePaymentAccountVerificationToken = ({
  workspaceId,
  context,
}: {
  workspaceId: string;
  context: Partial<OperationContext>;
}) => {
  const [{ fetching }, createToken] =
    useCreatePaymentAccountVerificationTokenMutation();
  const createVerificationToken = useCallback(
    async (ledgerId: string) => {
      const response = await createToken({ workspaceId, ledgerId }, context);
      const result = getResultOrError(
        response.data?.createPaymentAccountVerificationToken,
        response.error
      );
      if (result.isError) throw new Error(result.errorMessage);
      return result.result;
    },
    [workspaceId, context, createToken]
  );
  return { createVerificationToken, fetching };
};
